import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

import { AuthService } from 'app/core/auth/auth.service';
import { AuthInterceptor } from 'app/core/auth/auth.interceptor';
import { SessionConflictDialogComponent } from 'app/core/auth/session-conflict-dialog/session-conflict-dialog.component';

@NgModule({
    declarations: [
        SessionConflictDialogComponent,
    ],
    imports: [
        CommonModule,
        HttpClientModule,
        MatButtonModule,
        MatDialogModule,
        MatIconModule,
    ],
    providers: [
        AuthService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true,
        },
    ],
    exports: [
        SessionConflictDialogComponent,
    ],
})
export class AuthModule {}
